import React from "react";
import SearchTips from "./SearchTips";
import HomeCategoryGridView from "./HomeCategoryGridView";
interface Props {
  originalTerm?: string;
  heading?: string;
  subText?: string;
  searchTips?: {
    heading: string;
    subText: string;
    id: number;
  }[];
}
const InvalidSearchResultsView = ({
  originalTerm,
  heading,
  subText,
  searchTips
}: Props) => {
  const defaultHeading = `Sorry, we couldn't find any matches for "${originalTerm || ""}"`;
  const defaultSubText = "Try entering a different search term.";
  return <div id="search-elastic" className="container expand no-filter container-product-listing" data-sentry-component="InvalidSearchResultsView" data-sentry-source-file="InvalidSearchResultsView.tsx">
      <div className="search__wrap" />
      <div id="page" className="fixed-go-to-top clears">
        <main id="main">
          <div id="product_listing" className="ag box ag-grid">
            <div className="padded">
              <h2 className="page-header">{heading || defaultHeading}</h2>
              <p>{subText || defaultSubText}</p>
            </div>
            <SearchTips searchTips={searchTips} data-sentry-element="SearchTips" data-sentry-source-file="InvalidSearchResultsView.tsx" />
          </div>
          <HomeCategoryGridView data-sentry-element="HomeCategoryGridView" data-sentry-source-file="InvalidSearchResultsView.tsx" />
        </main>
      </div>
    </div>;
};
export default InvalidSearchResultsView;